export function wiFiTitle({ online, rssi, connected, configured, }) {
    if (!configured) {
        return 'Не сконфигурирован Wi-Fi';
    }
    if (!online) {
        return 'Нет связи с устройством';
    }
    if (connected) {
        return `Подключен к Wi-Fi (rssi: ${rssi})`;
    }
    return `Не подключен к Wi-Fi`;
}
export function isWiFiNotConfigured(wifi_settings) {
    return (wifi_settings?.netname == null ||
        wifi_settings.netname == '' ||
        wifi_settings?.pass == null ||
        wifi_settings.pass == '');
}
export function rssiState(rssi) {
    if (rssi === 0 || rssi == null) {
        return 'Нет сигнала';
    }
    if (rssi > 90) {
        return 'Слабый';
    }
    if (rssi > 70) {
        return 'Удовлетворительный';
    }
    if (rssi > 52) {
        return 'Хороший';
    }
    return 'Отличный';
}
export function rssiBar(rssi) {
    if (rssi === 0 || rssi == null) {
        return 0;
    }
    if (rssi > 90) {
        return 1;
    }
    if (rssi > 70) {
        return 2;
    }
    if (rssi > 52) {
        return 3;
    }
    return 4;
}
